// Add two values together, any NaN will be default to 0
const safeAdd = (a, b) => {
  const toNumber = (val) => {
    const num = Number(val);
    return isNaN(num) ? 0 : num;
  };

  return toNumber(a) + toNumber(b);
};

export { safeAdd };
